import '../utils/GoogleIdentityService'

export default defineNuxtPlugin(() => {})
